import React, { useEffect, useRef, useState } from 'react';
import Button from '../../../../component/ui/Button';
import Modal from '../../../../component/modal/Modal';
import InputField from '../../../../component/form/FormInput';
import { PageSmallLoader } from '../../../../component/PageLoader';
import { toast } from 'react-toastify';
import { getDefaultProductList } from '../../../../services/products';
import { useNavigate } from 'react-router-dom';

export default function ProductMasterModel({ isProductMasterOpen, setIsProductMasterOpen }) {
	const [searchText, setSearchText] = useState('');
	const [isLoader, setLoader] = useState(false);
	const [productList, setProductList] = useState([]);
	const [params, setParams] = useState({
		page: 1,
		pageSize: 30,
		search: '',
	});
	const [selectedProductId, setSelectedProductId] = useState(null);
	const isFirstRender = useRef(true);
	const navigate = useNavigate();
	const suburl = localStorage.getItem('suburl');
	const handleClose = () => {
		setIsProductMasterOpen(false);
	};
	const handleClone = () => {
		navigate(`/user/${suburl}/product-create/${selectedProductId}`, { state: { clone: true } });
		setIsProductMasterOpen(false);
		setSelectedProductId(null);
	};
	const toggleProduct = (id) => {
		if (selectedProductId !== id) {
			setSelectedProductId(id);
		} else {
			setSelectedProductId(null);
		}
	};

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return; // ⛔ skip first render
		}
		const debounceTimer = setTimeout(() => {
			setParams((prev) => ({
				...prev,
				search: searchText,
			}));
			setSelectedProductId(null);
		}, 500); // ⏱ debounce delay (ms)

		return () => clearTimeout(debounceTimer);
	}, [searchText]);

	const fetchDefaultProductList = async () => {
		try {
			setLoader(true);
			const { master_products } = await getDefaultProductList(params);
			setProductList(master_products);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setLoader(false);
		}
	};

	useEffect(() => {
		fetchDefaultProductList();
	}, [params]);

	return (
		<Modal
			className="addCardModel"
			title={`Product Master`}
			// secondaryText={`${cardsState.filter((card) => card.is_checked).length} of ${cardsState.length} selected`}
			isOpen={isProductMasterOpen}
			onClose={handleClose}
			cancelButton={handleClose}
		>
			<div className="d-flex flex-row gap-4 align-items-center py-4">
				<div className="col">
					<InputField
						label=""
						placeholder="Search"
						type="text"
						autoComplete="off"
						required={false}
						autoFocus={false}
						value={searchText}
						onChange={setSearchText}
					/>
				</div>
				<div
					className="lead text-secondary cursor-pointer"
					onClick={() => {
						setSearchText('');
						setSelectedProductId(null);
					}}
				>
					Reset
				</div>
			</div>
			<div className="text-start py-2 text-muted">Select the product you want to clone.</div>
			<div style={{ width: '100%', height: '450px', overflow: 'auto' }}>
				{isLoader ? (
					<div className="d-flex justify-content-center">
						<PageSmallLoader />
					</div>
				) : productList.length === 0 ? (
					<div className="text-center py-4 text-muted">No Product found.</div>
				) : (
					productList.map((product, index) => (
						<div
							key={index}
							style={{
								display: 'flex',
								alignItems: 'center',
								marginBottom: '10px',
								borderRadius: '8px',
								gap: '10px',
								padding: '8px 11px',
								backgroundColor: '#EDEDF7',
							}}
						>
							<input
								type="checkbox"
								checked={product.master_product_id === selectedProductId}
								onChange={(e) => toggleProduct(product.master_product_id)}
								style={{ width: '15px', height: '15px', cursor: 'pointer' }}
							/>
							<span className="lead text-secondary">{product.name}</span>
						</div>
					))
				)}
			</div>

			<div
				className="d-flex justify-content-end align-items-center gap-4 py-4 right-0"
				style={{ overflow: 'hidden', position: 'static' }}
			>
				<Button
					type="button"
					button="Cancel"
					className="mt-0 px-4 btn-gray relative"
					onClick={handleClose}
				/>
				<Button
					type="button"
					button="Clone"
					className="mt-0 px-4 btn-primary relative"
					onClick={handleClone}
				/>
			</div>
		</Modal>
	);
}
